/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { EUserPermissionAccess } from "../redux/ducks/AccessControl/types"


/**
 * Function to determine if the Plan of Record menu item should be disabled based on user permissions
 * @param hasWriteAccess 
 * @param ownerId 
 * @param currentUserId 
 * @returns true if the Plan of Record menu item should be disabled, false otherwise
 */
const planOfRecordDisablePermissions = (hasWriteAccess: boolean, ownerId: string, currentUserId: string) => {
    return !(hasWriteAccess && currentUserId === ownerId)
  }

/**
 * Function to determine if the delete menu item should be disabled based on user permissions
 * @param isUserAdmin 
 * @param userAccessLevel 
 * @param ownerId 
 * @param currentUserId 
 * @returns true if the delete menu item should be disabled, false otherwise
 */
const deleteDisablePermissions = (isUserAdmin: boolean, userAccessLevel: string, ownerId: string, currentUserId: string) => {
    return !(isUserAdmin || (userAccessLevel === EUserPermissionAccess.READ_WRITE && currentUserId === ownerId))
  }
  
const checkDownloadMenuItemPermission = (isUserAdmin: boolean, userAccessLevel: string, hasWriteAccess: boolean, menuType: string) => {
  if (menuType === 'Spreadsheet') {
    return isUserAdmin
  } else if (menuType === 'CSV' || menuType === 'JSON' ) {
    return hasWriteAccess || userAccessLevel === EUserPermissionAccess.READ_ONLY
  }
  return false
}
/**
 * Function to determine if the user has admin or owner permissions
 * @param isUserAdmin 
 * @param ownerId 
 * @param currentUserId 
 * @returns true if the user does not have admin or owner permissions, false otherwise
 */
const allowAdminOrOwnerPermissions = (isUserAdmin: boolean, ownerId: string, currentUserId: string) => {
  return !(isUserAdmin || currentUserId === ownerId)
}
/**
 * Determines the save state based on the current state and a previous default state.
 *
 * @param currentState - The current state indicating whether saving is allowed or not.
 *                        If `false`, saving is not allowed regardless of the previous default state.
 * @param previousDefaultState - The default state indicating whether saving is allowed or not.
 *                                Used when `currentState` is not `false`.
 * @returns A boolean value representing the save state:
 *          - `false` if `currentState` is `false`.
 *          - `previousDefaultState` otherwise.
 */
const determineSaveState = (isSaveAllowed: boolean, defaultSaveState: boolean) => {
  return isSaveAllowed === false ? isSaveAllowed : defaultSaveState
}
export {
    planOfRecordDisablePermissions,
    deleteDisablePermissions,
    checkDownloadMenuItemPermission,
    allowAdminOrOwnerPermissions,
    determineSaveState    
}